// extracted by mini-css-extract-plugin
export default {"pageTitle":"global_pageTitle__0+Zlz"};